// ==============================|| OVERRIDES - BUTTON ||============================== //

export default function Button(theme) {
  const disabledStyle = {
    '&.Mui-disabled': {
      backgroundColor: theme.palette.grey[200]
    }
  };

  return {
    MuiButton: {
      defaultProps: {
        disableElevation: false
      },
      variants: [
        {
          // Landing page login button
          props: { variant: 'landing-login' },
          style: {
            backgroundColor: '#fff',
            color: '#673ab7',
            textTransform: 'none',
            paddingLeft: '16px',
            paddingRight: '16px',
            paddingTop: '6px',
            paddingBottom: '6px',
            fontSize: '0.875rem',
            fontWeight: 600,
            boxShadow: 'none',
            borderRadius: '8px !important',
            borderTopLeftRadius: '8px !important',
            borderTopRightRadius: '8px !important',
            borderBottomLeftRadius: '8px !important',
            borderBottomRightRadius: '8px !important',
            border: '2px solid #fff',
            overflow: 'visible',
            '&:hover': {
              backgroundColor: '#f3e5f5',
              boxShadow: '0 2px 8px rgba(255, 255, 255, 0.3)',
              borderColor: '#fff'
            }
          }
        },
        {
          // Landing page card action buttons
          props: { variant: 'landing-action' },
          style: {
            backgroundColor: '#673ab7',
            color: '#fff',
            textTransform: 'uppercase',
            fontSize: '0.75rem',
            fontWeight: 600,
            borderRadius: '8px',
            boxShadow: 'none',
            padding: '8px 12px',
            minWidth: '110px',
            height: '36px',
            whiteSpace: 'nowrap',
            '&:hover': {
              backgroundColor: '#5e35b1',
              boxShadow: '0 2px 8px rgba(103, 58, 183, 0.3)'
            },
            '& .MuiButton-endIcon': {
              marginLeft: '8px'
            },
            '& .MuiButton-startIcon': {
              marginRight: '8px'
            }
          }
        }
      ],
      styleOverrides: {
        root: {
          fontWeight: 500,
          textTransform: 'capitalize',
          borderRadius: '10px',
          padding: '10px 24px',
          fontSize: '0.875rem',
          transition: 'all 0.3s ease'
        },
        contained: {
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: '#fff',
          boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',
          marginRight: '12px',
          '&:hover': {
            background: 'linear-gradient(135deg, #5568d3 0%, #63408a 100%)',
            boxShadow: '0 6px 18px rgba(102, 126, 234, 0.4)',
            transform: 'translateY(-2px)'
          },
          ...disabledStyle
        },
        containedPrimary: {
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          '&:hover': {
            background: 'linear-gradient(135deg, #5568d3 0%, #63408a 100%)'
          }
        },
        outlined: {
          borderWidth: '0px',
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: '#fff',
          fontWeight: 600,
          boxShadow: '0 4px 12px rgba(102, 126, 234, 0.3)',          marginBottom: '16px',
          marginRight: '12px',          '&:hover': {
            borderWidth: '0px',
            background: 'linear-gradient(135deg, #5568d3 0%, #63408a 100%)',
            boxShadow: '0 6px 18px rgba(102, 126, 234, 0.4)',
            color: '#fff',
            transform: 'translateY(-2px)'
          },
          ...disabledStyle
        },
        outlinedPrimary: {
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: '#fff',
          borderWidth: '0px',
          '&:hover': {
            background: 'linear-gradient(135deg, #5568d3 0%, #63408a 100%)',
            color: '#fff',
            borderWidth: '0px'
          }
        },
        text: {
          color: '#667eea',
          '&:hover': {
            background: 'rgba(102, 126, 234, 0.08)',
            color: '#5568d3'
          }
        }
      }
    }
  };
}
